import type { SVGProps } from 'react'

interface Structure3DIconProps extends SVGProps<SVGSVGElement> {}

export function Structure3DIcon(props: Structure3DIconProps) {
  return (
    <svg
      width="44"
      height="39"
      viewBox="0 0 44 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0318 34.2502L8.45261 30.4779C8.25559 30.4078 8.12451 30.2215 8.12451 30.0121V17.2624C8.28609 17.2822 8.45179 17.2929 8.61913 17.2929C10.5317 17.2929 12.1326 15.9393 12.5159 14.1396L21.5626 17.2838C21.3532 17.5451 21.2337 17.8765 21.2378 18.2269L21.3936 31.4333C20.2106 31.9263 19.3145 32.9741 19.0318 34.2502Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3807 31.1653L22.2273 18.2153C22.2249 18.0051 22.3559 17.8163 22.5538 17.7446L32.0275 14.3168C32.4289 16.0917 34.0183 17.4206 35.9135 17.4206C36.099 17.4206 36.2812 17.4082 36.4593 17.3835L36.6184 29.5966C36.62 29.6328 36.6167 29.6707 36.6093 29.7078C36.5772 29.8694 36.4667 30.0046 36.315 30.0681L26.7614 34.0482C26.2948 32.3664 24.7507 31.1282 22.9223 31.1282C22.7384 31.1282 22.5571 31.1414 22.3807 31.1653Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5496 9.01285C22.2767 9.01285 22.0549 8.79109 22.0549 8.51823V0.493798C22.0549 0.220931 22.2767 0 22.5496 0C22.8224 0 23.0442 0.220931 23.0442 0.493798V8.51823C23.0442 8.79109 22.8224 9.01285 22.5496 9.01285Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3954 32.4415C1.17776 32.4415 0.97744 32.2964 0.918909 32.0755C0.848013 31.8117 1.00464 31.5404 1.26844 31.4695L8.49076 29.5339C8.75456 29.4638 9.02578 29.6197 9.09667 29.8843C9.16674 30.1473 9.01094 30.4185 8.74714 30.4894L1.524 32.425C1.48113 32.4365 1.43826 32.4415 1.3954 32.4415Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.6027 33.847C42.5195 33.847 42.4346 33.8256 42.3562 33.7802L35.8775 30.0401C35.6409 29.9032 35.5601 29.6007 35.6961 29.3641C35.833 29.1283 36.1355 29.0467 36.3721 29.1835L42.8509 32.9237C43.0875 33.0606 43.1683 33.3631 43.0322 33.5997C42.9399 33.758 42.7742 33.847 42.6027 33.847Z"
        fill="currentColor"
      />
      <path
        d="M12.1975 11.556L22.3892 8.0508C22.4964 8.01371 22.6143 8.01453 22.7206 8.0541L32.3748 11.6071C32.1102 12.1174 31.9527 12.6912 31.9321 13.2996L22.7124 16.635L12.599 13.1207C12.5734 12.5618 12.4308 12.0325 12.1975 11.556Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9225 38.1074C21.2705 38.1074 19.9276 36.7645 19.9276 35.1125C19.9276 33.4612 21.2705 32.1175 22.9225 32.1175C24.5738 32.1175 25.9175 33.4612 25.9175 35.1125C25.9175 36.7645 24.5738 38.1074 22.9225 38.1074ZM35.9138 16.4314C34.2626 16.4314 32.9189 15.0885 32.9189 13.4364C32.9189 11.7852 34.2626 10.4415 35.9138 10.4415C37.565 10.4415 38.9087 11.7852 38.9087 13.4364C38.9087 15.0885 37.565 16.4314 35.9138 16.4314ZM8.6197 16.3036C6.96766 16.3036 5.62476 14.9599 5.62476 13.3087C5.62476 11.6574 6.96766 10.3137 8.6197 10.3137C10.2709 10.3137 11.6146 11.6574 11.6146 13.3087C11.6146 14.9599 10.2709 16.3036 8.6197 16.3036Z"
        fill="currentColor"
      />
    </svg>
  )
}
